import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "favoritenlisteAnzeige",
  class: "box"
}
const _hoisted_2 = {
  key: 0,
  class: "list-unstyled mb-2"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "show-arrow linktolist font-weight-bold mb-3" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "favorite" }, "Favoriten", -1)),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errormsg: "Beim Laden ist ein Fehler aufgetreten."
    }, {
      default: _withCtx(() => [
        (_ctx.favourites.length >0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favourites, (favorite, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "show-arrow"
                }, [
                  _createElementVNode("a", {
                    href: _ctx.sanitizeUrl(favorite.resolvedUrl || favorite.externalUrl),
                    class: "file",
                    target: "_blank",
                    rel: "noreferrer noopener"
                  }, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", {
                      class: "icon icon-navigation_pfeil_rechts_mittel",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(favorite.resolvedName||favorite.name), 1)
                  ], 8, _hoisted_3)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, " Keine Favoriten gesetzt. "))
      ]),
      _: 1
    }, 8, ["state"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        href: _ctx.sanitizeUrl(_ctx.verweisAlleLinks())
      }, [...(_cache[1] || (_cache[1] = [
        _createTextVNode("zur Linkverwaltung ", -1),
        _createElementVNode("i", {
          class: "fas fa-chevron-right ms-1",
          "aria-hidden": "true"
        }, null, -1)
      ]))], 8, _hoisted_6)
    ])
  ]))
}